<template>
	<div class="dialog">
		<el-dialog title="申请退票" :visible.sync="isShowTourist" width="70%" :before-close="handleClose">
			<div class="header">
				<div class="searchbox flex-row">
					<el-input type="text" placeholder="请输入您要搜索的参观人姓名或身份证号" v-model="value">
					</el-input>
					<div class="search" @click="Search">
						查询
					</div>
				</div>
				<div class="nav flex-row">
					<div class="nav-item" :class="currentTab==0?'activeNav':''" @click="changeTab(0)">
						可申请退票游客
					</div>
					<div class="nav-item" :class="currentTab==1?'activeNav':''" @click="changeTab(1)">
						已申请退票游客
					</div>
				</div>
			</div>
			<div class="table">
				<el-table :data="waitList" stripe height="500" style="width: 100%;"
					:header-cell-style="{background:'#F4F4F4',color:'#BB2916',textAlign:'center',}"
					@selection-change="handleSelectionChange" v-if="currentTab==0">
					<el-table-column type="selection" width="85">
					</el-table-column>
					<el-table-column type="index" label="序号" width="180">
					</el-table-column>
					<el-table-column prop="customerName" label="姓名">
					</el-table-column>
					<el-table-column label="证件类型">
						<template slot-scope="scope">
							身份证
						</template>
					</el-table-column>
					<el-table-column prop="customerIdCard" label="证件号码">
					</el-table-column>
					<el-table-column prop="productName" label="门票名称">
					</el-table-column>
					<el-table-column prop="productPrice" label="票价">
					</el-table-column>
					<el-table-column label="使用状态">
						<template>
							<div class="status">
								待使用
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="table1">
				<el-table :data="returnList" height="500" style="width: 100%;"
					:header-cell-style="{background:'#F4F4F4',color:'#BB2916',textAlign:'center',}"
					v-if="currentTab==1">
					<el-table-column type="index" label="序号" width="180">
					</el-table-column>
					<el-table-column prop="customerName" label="姓名">
					</el-table-column>
					<el-table-column label="证件类型">
						<template slot-scope="scope">
							身份证
						</template>
					</el-table-column>
					<el-table-column prop="customerIdCard" label="证件号码">
					</el-table-column>
					<el-table-column prop="productName" label="门票名称">
					</el-table-column>
					<el-table-column prop="productPrice" label="票价">
					</el-table-column>
					<el-table-column label="使用状态">
						<template>
							<div class="status">
								已退票
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer flex-row" v-if="currentTab==0">
				<div class="total flex-row">
					总额：￥{{totalPrice}}
					<div class="returnbtn" @click="CancelOrder">
						确定退票
					</div>
				</div>
				<!-- 	<el-pagination background layout="prev, pager, next" :total="22">
				</el-pagination> -->
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		merchantNo,
		CancelOrder,
		getCustomerUserList
	} from '@/utils/http.js'
	export default {
		name: 'TouristList',
		props: {
			isShowTourist: {
				type: Boolean,
				default: false
			},
			orderNo: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				value: '',
				currentTab: 0,
				returnList: [],
				waitList: [],
				totalPrice: 0,
				chooseId: []
			}
		},
		mounted() {
			this.getCustomerUserList({
				orderSn: this.orderNo,
				keyWords: ''
			})
		},
		methods: {
			changeTab(val) {
				this.currentTab = val
			},
			// 弹窗关闭时触发
			handleClose() {
				this.$emit('changeDialog', false);
			},
			// 勾选事件
			handleSelectionChange(val) {
				let chooseId = []
				let totalPrice = 0
				for (let li of val) {
					chooseId.push(li.id)
					totalPrice = (parseFloat(totalPrice) + li.productPrice).toFixed(2)
				}
				this.chooseId = chooseId;
				this.totalPrice = totalPrice
			},
			// 点击搜索
			Search() {
				this.getCustomerUserList({
					orderSn: this.orderNo,
					keyWords: this.value,
				})
			},
			//获取退单游客名单
			getCustomerUserList(param) {
				getCustomerUserList(param).then((res) => {
					if (param.keyWords != '' && this.currentTab == 0 && this.waitList.length == 0) {
						this.$message({
							message: '未搜索到该内容',
							type: 'success',
							offset: '400',
							duration: '1000'
						});
						return
					}
					if (param.keyWords != '' && this.currentTab == 1 && this.returnList.length == 0) {
						this.$message({
							message: '未搜索到该内容',
							type: 'success',
							offset: '400',
							duration: '1000'
						});
						return
					}
					this.returnList = res.data.refueList //已退列表
					this.waitList = res.data.waitList //未退列表
				})
			},
			// 确定退票
			CancelOrder() {
				if (this.chooseId.length == 0) {
					this.$message({
						message: '请先选择需要退票的游客！',
						type: 'success',
						offset: '400',
						duration: '1000'
					});
					return
				}
				let that = this
				this.$confirm('是否确认取消预约?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'confirm',
					type: 'warning'
				}).then(() => {
					let param = {
						merchantNo: merchantNo, //商户号
						orderSn: that.orderNo, //订单号
						orderUserId: that.chooseId //单个取消的用户ID
					}
					CancelOrder(param).then((res) => {
						this.$message({
							message: '取消成功',
							type: 'success',
							offset: '400',
							duration: '1000'
						});
						// 刷新列表数据
						this.getCustomerUserList({
							orderSn: this.orderNo,
							keyWords: ''
						})
					})
				}).catch(() => {});
			},
		},
	}
</script>

<style scoped>
	.header {
		margin-bottom: 24px;
	}

	.searchbox .search {
		width: 72px;
		height: 40px;
		background: #BB2916;
		border-radius: 10px;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 40px;
		text-align: center;
		margin-left: 12px;
	}

	.header .nav {
		margin-top: 14px;
	}

	.header .nav-item {
		width: 170px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 10px;
		border: 1px solid #999999;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
		line-height: 40px;
		text-align: center;
		margin-right: 12px;
	}

	/* nav激活样式 */
	.activeNav {
		background: #BB2916 !important;
		border: none !important;
		color: #ffffff !important;
	}

	.table .status {
		width: 48px;
		height: 24px;
		background: #E9D095;
		border-radius: 4px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #5D3F02;
		line-height: 24px;
		text-align: center;
		margin: auto;
	}

	.table1 .status {
		width: 48px;
		height: 24px;
		background: #E34D59;
		border-radius: 4px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		line-height: 24px;
		text-align: center;
		margin: auto;
	}

	.footer .total {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #E34D59;
	}

	.footer {
		justify-content: space-between;
		margin-top: 24px;
	}

	.footer .total .returnbtn {
		width: 125px;
		height: 40px;
		background: #FAFAFA;
		border-radius: 6px;
		border: 1px solid #BB2916;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #BB2916;
		line-height: 40px;
		text-align: center;
		margin-left: 38px;
	}

	/deep/ .el-dialog__header {
		height: 42px;
		background: #BB2916;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0 24px;
		box-sizing: border-box;
		justify-content: space-between;
	}

	/deep/ .el-dialog__body {
		padding: 32px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF !important;
	}

	/deep/ .el-dialog__headerbtn {
		width: 16px;
		height: 16px;
		position: inherit;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #FFFFFF !important;
	}

	/deep/ .searchbox .el-input {
		width: 356px;
		height: 40px;
	}

	/deep/ .searchbox .el-input__inner {
		width: 356px;
		height: 40px;
		background: #ffffff;
		border: 1px solid #E9E9E9;
		border-radius: 10px;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
	}

	/deep/.table .el-table__row .cell {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 400;
		color: #333333;
		text-align: center;
	}

	/deep/.table1 .el-table__row .cell {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 400;
		color: #999999;
		text-align: center;
	}

	/deep/ .el-table__row {
		height: 56px;
	}

	/deep/.table .el-table__row .el-table__cell:nth-child(7) .cell {
		font-weight: 600;
	}

	/deep/.table1 .el-table__row .el-table__cell:nth-child(7) .cell {
		font-weight: 600;
		color: #E34D59;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #BB2916;
		border-color: #BB2916;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: unset;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #BB2916;
	}

	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/ .el-checkbox__inner:hover {
		border-color: #BB2916 !important;
	}
</style>